import settings from '/@/core/settings';
import { getNodesFromAPI } from '/@/store/zones/apiProviders';

export const cropZones = ['soy', 'corn'];
export const agronomicZones = cropZones.concat('weeds');

export const findNodeByLngLat = async (
    lng: number,
    lat: number,
    allZones: any[] | undefined,
    countryCode: any | undefined
) => {
    const { gridStart, gridEnd, gridStep } = settings.zones;

    const allZonesAsMap = new Map((allZones || []).map((zone) => [zone.id, zone]));

    // const rows = (gridEnd[1] - gridStart[1]) / gridStep;
    const cols = (gridEnd[0] - gridStart[0]) / gridStep;

    const gridY = Math.floor((lat - gridStart[1] - gridStep / 2) / gridStep);
    const gridX = Math.floor((lng - gridStart[0] - gridStep / 2) / gridStep);

    const index = gridY * cols + gridX;
    const node = await getNodesFromAPI(index);
    if (!node) return;

    const zones = node.zones
        .map((zone) => allZonesAsMap.get(zone.id))
        .filter((zone) => !countryCode || zone.country === countryCode);
    const crops = cropZones.filter((crop) => zones.find((zone) => zone.type === crop));
    return { ...node, zones, crops, index };
};

export const getFrozenDate = (zones, allHistoricGDUs) => {
    const historicGDUsZone = zones.find((zone) => zone.type === settings.enums.zoneTypes.gdu.value);
    const historicGDUsZoneId = historicGDUsZone && historicGDUsZone.id;
    const historicGDUs = allHistoricGDUs.find((historicGDUs) => historicGDUs.zone === historicGDUsZoneId);
    if (historicGDUs) {
        return historicGDUs.firstFrozenDate;
    }
    return undefined;
};

const zoneByType = (type) => (zone) => zone.type === (settings.enums.zoneTypes[type] || {}).value;
export const getZoneByType = (zones, type) => zones.find(zoneByType(type));
export const getZonesByType = (zones, type) => zones.filter(zoneByType(type));
